import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import PageShell from './PageShell';
import Seo from '../components/Seo';
import { useCart } from '../context/CartContext';
import { staticImg, fmtMoney } from '../utils/media';
import { EmptyState } from '../components/StateHelpers';
import { ShoppingCart, Plus, Minus, Trash2, ArrowRight, ShoppingBag } from 'lucide-react';

export default function Cart() {
  const { items, update, remove, total, count, clear } = useCart();
  const nav = useNavigate();

  return (
    <PageShell eyebrow="SEPET" title={<><span className="text-white">Alışveriş </span><span className="gold-text">Sepetim</span></>} subtitle={`${count} ürün sepetinizde bekliyor.`}>
      <Seo title="Sepet" />
      <section className="pb-24">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-10">
          {items.length === 0 ? (
            <EmptyState icon={ShoppingCart} title="Sepetiniz Boş" subtitle="En sevdiğiniz Aegis ürünlerini keşfedin."
              action={<Link to="/products" className="btn-gold h-11 px-6 rounded-full text-xs font-extrabold tracking-widest inline-flex items-center gap-2">ÜRÜNLERİ KEŞFET <ArrowRight className="w-4 h-4" /></Link>} />
          ) : (
            <div className="grid lg:grid-cols-[1.4fr_1fr] gap-8">
              <div className="space-y-3">
                {items.map((it) => (
                  <div key={it.product_id} className="flex gap-4 p-4 rounded-2xl border border-white/8 bg-gradient-to-b from-[#111015] to-[#0a090c]">
                    <div className="w-24 h-24 rounded-xl overflow-hidden bg-[#0f0e12] shrink-0">
                      <img src={staticImg(it.image)} alt={it.name} className="w-full h-full object-cover" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <Link to={`/products/${it.slug}`} className="font-display text-lg font-bold text-white hover:text-[#f4d896]">{it.name}</Link>
                      <div className="gold-text font-display text-xl font-black mt-1">{fmtMoney(it.price)} ₺</div>
                      <div className="flex items-center gap-3 mt-2">
                        <div className="inline-flex items-center gap-1 rounded-full border border-white/10 bg-white/5">
                          <button onClick={() => update(it.product_id, it.quantity - 1)} className="w-8 h-8 flex items-center justify-center text-white/70 hover:text-white"><Minus className="w-3.5 h-3.5" /></button>
                          <span className="w-8 text-center text-sm text-white">{it.quantity}</span>
                          <button onClick={() => update(it.product_id, it.quantity + 1)} className="w-8 h-8 flex items-center justify-center text-white/70 hover:text-white"><Plus className="w-3.5 h-3.5" /></button>
                        </div>
                        <button onClick={() => remove(it.product_id)} className="text-red-400/80 hover:text-red-400 text-xs flex items-center gap-1"><Trash2 className="w-3.5 h-3.5" /> Kaldır</button>
                      </div>
                    </div>
                    <div className="text-right shrink-0">
                      <div className="text-xs text-white/40">TOPLAM</div>
                      <div className="font-display text-lg font-black text-white">{fmtMoney(it.price * it.quantity)} ₺</div>
                    </div>
                  </div>
                ))}
                <button onClick={clear} className="text-xs text-white/50 hover:text-red-400 inline-flex items-center gap-1 mt-2"><Trash2 className="w-3.5 h-3.5" /> Sepeti boşalt</button>
              </div>

              <aside className="h-fit lg:sticky lg:top-24 rounded-3xl border border-[#e4b44e]/30 bg-gradient-to-b from-[#1a1710] to-[#0a090c] p-6 md:p-8">
                <h3 className="font-display text-xl font-bold text-white mb-6">Sipariş Özeti</h3>
                <div className="space-y-3 text-sm">
                  <div className="flex justify-between text-white/70"><span>Ara Toplam</span><span>{fmtMoney(total)} ₺</span></div>
                  <div className="flex justify-between text-white/70"><span>KDV (%20 Dahil)</span><span className="text-emerald-400">Dahil</span></div>
                  <div className="border-t border-white/10 pt-3 flex justify-between text-white items-baseline"><span className="font-display font-bold">Toplam</span><span className="font-display text-3xl font-black gold-text">{fmtMoney(total)} ₺</span></div>
                </div>
                <button onClick={() => nav('/checkout')} className="w-full mt-6 btn-gold h-12 rounded-full inline-flex items-center justify-center gap-2 text-sm font-extrabold tracking-widest">
                  <ShoppingBag className="w-4 h-4" /> ÖDEMEYE GEÇ
                </button>
                <div className="text-xs text-white/40 mt-4 text-center">Ödemeler güvenli SSL ile korunur.</div>
              </aside>
            </div>
          )}
        </div>
      </section>
    </PageShell>
  );
}
